// 🔑 A CANCELLED REQUEST IS NOT SHOWN TO THE BORROWER (Hannah's review, Jesse 2026-11-02 item 5) — the mirror of
// backend/constants/borrowerRequestVisibility.js (the server filters; the page applies the same rule, so an old server
// answer never lists one). backend/test/borrowerRequestVisibility.test.js holds the two together.
export const CLOSED_REQUEST_STATUSES = ['cancelled', 'canceled', 'withdrawn', 'superseded', 'void', 'voided', 'revoked'];

/** Is this request row shown to the borrower? r: { status?, cancelled_at?, withdrawn_at? } */
export function shownToBorrower(r) {
  if (!r) return false;
  if (CLOSED_REQUEST_STATUSES.includes(String(r.status || '').toLowerCase())) return false;
  if (r.cancelled_at || r.withdrawn_at) return false;
  return true;
}
